import { DefaultButton, Panel, PanelType, Separator, Stack, Text, TextField } from '@fluentui/react';
import React from 'react';
import PrimaryButton from '../../../../Forms/PrimaryButton';

const customStyles = {
    root: {
        backgroundColor: '#d13438', // A shade of red for the default state
        color: '#ffffff', // White text color for contrast
    },
    rootHovered: {
        backgroundColor: '#a4262c', // A darker shade of red for the hovered state
        color: '#ffffff',
    },
    rootPressed: {
        backgroundColor: '#761e1e', // An even darker shade of red for the pressed state
    },
};

const ToolsPanel = ({
    newQuoteText,
    setNewQuoteText,
    saveQuoteWrapper,
    dismissPanel,
    updatingItem,
    postUserQuoteLoading,
    voidWinnerWrapper,
}) => {
    const maxQuoteLength = 250;

    return (
        <Panel isOpen={!!updatingItem} onDismiss={dismissPanel} type={PanelType.smallFixedFar} headerText="Tools">
            {updatingItem && (
                <>
                    <Stack tokens={{ childrenGap: 20 }}>
                        <Separator />
                        <Text variant="large">Quote</Text>
                        <Text variant="medium">
                            Set a new Quote for user {updatingItem.firstName} {updatingItem.lastName}
                        </Text>
                        <TextField
                            label="New Quote"
                            multiline
                            rows={9}
                            value={newQuoteText}
                            onChange={(e, newValue) => setNewQuoteText(newValue)}
                            description={
                                newQuoteText.length <= maxQuoteLength
                                    ? `${newQuoteText.length} / ${maxQuoteLength} characters`
                                    : null
                            }
                            errorMessage={
                                newQuoteText.length > maxQuoteLength
                                    ? `${newQuoteText.length} / ${maxQuoteLength} characters`
                                    : null
                            }
                        />
                        <Stack horizontal tokens={{ childrenGap: 20 }}>
                            <PrimaryButton
                                text="Save"
                                onClick={saveQuoteWrapper}
                                disabled={
                                    !newQuoteText.trim() || postUserQuoteLoading || newQuoteText.length > maxQuoteLength
                                }
                            />
                            <DefaultButton text="Cancel" onClick={dismissPanel} />
                        </Stack>
                        <Separator />
                        <PrimaryButton
                            text="VOID User (this month only)"
                            onClick={voidWinnerWrapper}
                            styles={customStyles}
                        />
                    </Stack>
                </>
            )}
        </Panel>
    );
};

export default ToolsPanel;
